import { OperationType, ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { MentoringReportsFilterMetaModel } from "./mentoring-filter-meta-model";

export class MentoringReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new MentoringReportsFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Mentorship Report',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Mentoring_Report_' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download Mentoring Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'Email', value: 'orgemail' }, { key: 'Contact', value: 'orgmobile' }, { key: 'Gender', value: 'orggender' }, { key: 'Batch', value: 'batch_name' }, { key: 'Branch', value: 'branch_name' }, { key: 'Region', value: 'region' }, { key: 'State', value: 'StateName' }, { key: 'Mentor', value: 'mentor_name' }, { key: 'Mentor_Email', value: 'mentor_email' }, { key: 'Mentor_Contact', value: 'mentor_mobile' }, {key: 'year1_quarter1_doc', value: 'y1q1Doc'}, {key: 'year1_quarter2_doc', value: 'y1q2Doc'}, {key: 'year1_quarter3_doc', value: 'y1q3Doc'}, {key: 'year1_quarter4_doc', value: 'y1q4Doc'},{key: 'year2_quarter1_doc', value: 'y2q1Doc'}, {key: 'year2_quarter2_doc', value: 'y2q2Doc'}, {key: 'year2_quarter3_doc', value: 'y3q3Doc'}, {key: 'year2_quarter4_doc', value: 'y4q4Doc'},{key: 'year3_quarter1_doc', value: 'y3q1Doc'}, {key: 'year3_quarter2_doc', value: 'y3q2Doc'}, {key: 'year3_quarter3_doc', value: 'y3q3Doc'}, {key: 'year3_quarter4_doc', value: 'y3q4Doc'},{key: 'year4_quarter1_doc', value: 'y4q1Doc'}, {key: 'year4_quarter2_doc', value: 'y4q2Doc'}, {key: 'year4_quarter3_doc', value: 'y4q3Doc'}, {key: 'year4_quarter4_doc', value: 'y4q4Doc'},] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            { isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: '' },
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const email = new Headers('Email', 'orgemail', false, false, 'text');
        const contact = new Headers('Contact', 'orgmobile', false, false, 'text');
        const gender = new Headers('Gender', 'orggender', false, false, 'text');
        const batch = new Headers('Batch', 'batch_name', false, false, 'text');
        const branch = new Headers('Branch', 'branch_name', false, false, 'text');
        const region = new Headers('Region', 'region', false, false, 'text');
        const state = new Headers('State', 'StateName', false, false, 'text');
        const mentor_name = new Headers('Mentor Name', 'mentor_name', false, false, 'text');
        const mentor_email = new Headers('Mentor Email', 'mentor_email', false, false, 'text');
        const mentor_mobile = new Headers('Mentor Mobile', 'mentor_mobile', false, false, 'text');
        const year1_quarter1_doc = new Headers('Year 1 & Quarter 1', 'y1q1Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const year1_quarter2_doc = new Headers('Year 1 & Quarter 2', 'y1q2Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const year1_quarter3_doc = new Headers('Year 1 & Quarter 3', 'y1q3Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const year1_quarter4_doc = new Headers('Year 1 & Quarter 4', 'y1q4Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const year2_quarter1_doc = new Headers('Year 2 & Quarter 1', 'y2q1Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year2_quarter2_doc = new Headers('Year 2 & Quarter 2', 'y2q2Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year2_quarter3_doc = new Headers('Year 2 & Quarter 3', 'y2q3Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year2_quarter4_doc = new Headers('Year 2 & Quarter 4', 'y2q4Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year3_quarter1_doc = new Headers('Year 3 & Quarter 1', 'y3q1Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year3_quarter2_doc = new Headers('Year 3 & Quarter 2', 'y3q2Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year3_quarter3_doc = new Headers('Year 3 & Quarter 3', 'y3q3Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year3_quarter4_doc = new Headers('Year 3 & Quarter 4', 'y3q4Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year4_quarter1_doc = new Headers('Year 4 & Quarter 1', 'y4q1Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year4_quarter2_doc = new Headers('Year 4 & Quarter 2', 'y4q2Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year4_quarter3_doc = new Headers('Year 4 & Quarter 3', 'y4q3Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        
        const year4_quarter4_doc = new Headers('Year 4 & Quarter 4', 'y4q4Doc', false, false, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);

        headers.push(studentName);
        headers.push(email);
        headers.push(contact);
        headers.push(gender);
        headers.push(batch);
        headers.push(branch);
        headers.push(region);
        headers.push(state);
        headers.push(mentor_name);
        headers.push(mentor_email);
        headers.push(mentor_mobile);
        headers.push(year1_quarter1_doc);
        headers.push(year1_quarter2_doc);
        headers.push(year1_quarter3_doc);
        headers.push(year1_quarter4_doc);
        headers.push(year2_quarter1_doc);
        headers.push(year2_quarter2_doc);
        headers.push(year2_quarter3_doc);
        headers.push(year2_quarter4_doc);
        headers.push(year3_quarter1_doc);
        headers.push(year3_quarter2_doc);
        headers.push(year3_quarter3_doc);
        headers.push(year3_quarter4_doc);
        headers.push(year4_quarter1_doc);
        headers.push(year4_quarter2_doc);
        headers.push(year4_quarter3_doc);
        headers.push(year4_quarter4_doc);
        return headers;
    }

     override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
    }
}